<template>
  <div>
    <section class="page_box">
      <img src="../assets/img/homeBarrageImg/teacherBanner.png" />
    </section>
    <div id="bigBox">
      <section class="page_nav" :class="{ fixed: navFixed }">
        <ul>
          <li :class="{ active: activeNav === 0 }" @click="navClick(0)">
            讲师介绍
          </li>
          <li :class="{ active: activeNav === 1 }" @click="navClick(1)">
            课程体系
          </li>
        </ul>
      </section>
      <section class="content_box module_box">
        <div
          class="teacher_box animate__animated animate__fadeInLeft"
          v-if="activeNav === 0"
          id="teacher_box"
        >
          <h1 class="main_title">讲师介绍</h1>
          <ul class="teacher_list sub_module_box">
            <li v-for="item in teacherList" :key="item.id">
              <div class="img_box">
                <img :src="$utils.formatImgUrl(item.teacherImg)" alt="" />
              </div>
              <div class="teacher_info">
                <h1>{{ item.teacherName }}</h1>
                <div>
                  <p>
                    <span>{{ item.teacherTitle }}</span>
                    {{ item.teacherDesc }}
                  </p>
                </div>
                <div>
                  <p>
                    <span>过往履历</span>
                    {{ item.teacherResume }}
                  </p>
                </div>
              </div>
            </li>
            <!-- <li>
              <div class="img_box">
                <img src="../assets/img/teacher.png" alt="" />
              </div>
              <div class="teacher_info">
                <h1>林老师</h1>
                <div>
                  <p>
                    <span>创始人</span>
                    创始人，笃信学习改变创始人人生，致力于成为的职业生涯引路
                  </p>
                </div>
                <div>
                  <p>
                    <span>过往履历</span>
                    1994-1999年就读于清华大学，目前正致力于企业数智化经营解决方案专家企业数智化经营解决方案专家。
                  </p>
                </div>
              </div>
            </li> -->
          </ul>
        </div>
        <div
          class="course_box animate__animated animate__fadeInRight"
          v-if="activeNav === 1"
          id="course_box"
        >
          <template v-if="courseList.length <= 1">
            <CourseSolo />
          </template>
          <template v-else>
            <h1 class="main_title">课程体系</h1>
            <ul class="course_list sub_module_box">
              <li v-for="(item, index) in courseList" :key="index">
                <div>
                  <h2>{{ item.courseName }}</h2>
                  <p>
                    {{ item.courseDesc }}
                  </p>
                  <button @click="$utils.goPage('/courseDetail')">
                    了解更多
                  </button>
                </div>
                <img src="../assets/img/courseDetail.png" alt="" />
              </li>
            </ul>
          </template>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// import BannerText from "@/components/BannerText.vue";
import CourseSolo from "@/components/CourseSolo.vue";
import { getTeacherListApi } from "@/apis/index.js";
export default {
  name: "Teacher",
  components: {
    // BannerText,
    CourseSolo,
  },
  data() {
    return {
      activeNav: 0,
      navFixed: false,
      navTop: 0,
      teacherList: [],
      courseList: [
        {
          id: 1, // 唯一标识
          courseName: "课程名称", // 课程名称
          courseDesc: "课程描述", // 课程描述
          courseImg: ["http...", "http..."], // 课程封面图  在课程列表会显示其中一张 详情页全部展示
        },
      ],
    };
  },
  created() {
    this.getTeacherList();
  },
  mounted() {
    // 延迟获取page_nav元素的初始位置，确保DOM已经完全渲染
    setTimeout(() => {
      const navElement = document.querySelector(".page_nav");
      if (navElement) {
        this.navTop = navElement.offsetTop;
      }
    }, 500);

    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async getTeacherList() {
      let data = await getTeacherListApi();
      if (data.code === 200) {
        this.teacherList = data.result.records;
      } else {
        this.$utils.showToast(data.message);
      }
    },
    navClick(index) {
      // 更新激活状态
      this.activeNav = index;
      // 横向滚动到对应盒子
    },
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.scrollY;

      // 处理page_nav固定定位
      if (scrollTop >= this.navTop - 90) {
        // 90是顶部导航栏的高度
        this.navFixed = true;
      } else {
        this.navFixed = false;
      }

      // 处理顶部导航栏显示/隐藏
      const myNav = document.querySelector(".my_nav");
      if (myNav) {
        if (this.navFixed) {
          myNav.style.opacity = "0";
          myNav.style.transform = "translateY(-100%)";
          myNav.style.transition = "all 0.3s ease";
        } else {
          myNav.style.opacity = "1";
          myNav.style.transform = "translateY(0)";
          myNav.style.transition = "all 0.3s ease";
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.page_nav {
  width: 100%;
  position: relative;
  transition: all 0.3s ease;
  > ul {
    width: 340px;
    height: 60px;
    border-radius: 50px;
    background: #fff;
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);

    > li {
      width: 163px;
      line-height: 50px;
      opacity: 1;
      border-radius: 25px;
      box-sizing: border-box;
      font-size: 1.125rem;
      font-weight: 400;
      cursor: pointer;
    }
    > li.active {
      background: rgba(228, 245, 255, 1);
      color: rgba(7, 70, 255, 1);
      border: 1px solid rgba(228, 245, 255, 1);
    }
  }
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    padding: 0.625rem 0;
    > ul {
      position: relative;
      bottom: auto;
      left: auto;
      transform: none;
    }
  }
}

.content_box {
  width: 100%;
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0 8%;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  .teacher_box,
  .course_box {
    flex: 0 0 100%;
    width: 100%;
    min-width: 100%;
    padding: 0 1rem 1.25rem;
    box-sizing: border-box;
  }
}

.teacher_list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  > li {
    width: 48%;
    height: 19rem;
    opacity: 1;
    padding: 1.5rem;
    box-sizing: border-box;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 30px;
    position: relative;

    .img_box {
      position: absolute;
      bottom: -0.24rem;
      left: 1.5rem;
      > img {
        width: 10.5rem;
      }
    }

    .teacher_info {
      width: 60%;
      text-align: left;

      > h1 {
        font-size: 1.5rem;
        font-weight: 700;
        color: rgba(0, 0, 0, 1);
      }
      > div {
        width: 98%;
      }
      > div > p {
        font-size: 0.875rem;
        line-height: 1.75rem;
      }
      > div > p > span {
        padding: 0.25rem 0.375rem;
        margin-right: 0.375rem;
      }
      > div:first-of-type > p > span {
        background: rgba(235, 229, 234, 1);
        color: rgba(255, 127, 57, 1);
      }
      > div:first-of-type > p {
        margin: 1rem 0;
      }
      > div:last-of-type > p {
        color: #595959;
        > span {
          background: rgba(214, 230, 255, 1);
          color: #1278fd;
        }
      }
    }
  }
}
.course_list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  > li {
    width: 48%;
    height: 16.56rem;
    text-align: left;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
    margin-bottom: 30px;
    padding: 2rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > img {
      width: 14rem;
    }
    > div {
      > h2 {
        font-size: 1rem;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
      }
      > p {
        width: 90%;
        font-size: 0.75rem;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
        margin: 1.25rem 0 2.5rem;
        line-height: 1.375rem;
      }
      > button {
        width: 7.5rem;
        height: 2.875rem;
        border: 1px solid rgba(69, 111, 255, 1);
        font-size: 0.875rem;
        font-weight: 400;
        color: rgba(69, 111, 255, 1);
        background: none;
      }
    }
  }
}

/* 对于教师列表，保持原有的flex布局 */
.teacher_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;
  > li {
    flex: 0 0 calc(50% - 15px);
    margin-bottom: 0;
  }
}
</style>
